@use "variables" as *;

.description {
  width: 100%;
  font-size: $fontSize-xs;
  font-weight: bold;
  text-align: center;
  padding: $spacing-xs;
}

.card {
  width: fit-content;
}
